import { addSpanToAll } from '@atlaskit/react-ufo/interaction-metrics';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { PACKAGE_NAME, PACKAGE_TEAM_NAME } from '../../../common/constants.tsx';

interface FirstProject {
	projectId: string;
	projectTemplateKey: string;
}

export const getFirstProject = async (): Promise<FirstProject> => {
	try {
		if (fg('add_api_timing_to_perf_portal_for_queues_page')) {
			const fetchStartTime = performance.now();

			const response = await performGetRequest(
				'/rest/servicedesk/latest/xflow/getFirstProject?type=service_desk',
			);

			addSpanToAll(
				'fetch',
				'rest/servicedesk/latest/xflow/getFirstProject?type=service_desk',
				[{ name: 'network' }],
				fetchStartTime,
				performance.now(),
			);
			return response;
		}

		const response = await performGetRequest(
			'/rest/servicedesk/latest/xflow/getFirstProject?type=service_desk',
		);
		return response;

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		if (error.statusCode !== 404) {
			fireErrorAnalytics({
				meta: {
					id: 'getFirstProject',
					packageName: PACKAGE_NAME,
					teamName: PACKAGE_TEAM_NAME,
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
		}
		throw error;
	}
};
